export default "__VITE_ASSET__UJGR02J4__"